import { Component } from '@angular/core';
import { FacilityInformationType } from '@cargos/sprintpay-services';
import { WebSite } from 'src/app/shared/models/facility-information';
import { FACILITY_INFO } from './facility-information';

@Component({
    selector: 'app-facility-information',
    templateUrl: './facility-information.component.html',
    styleUrls: ['./facility-information.component.scss'],
    standalone: false,
})
export class FacilityInformationComponent {
    public facilityInformation: FacilityInformationType[];
    public webSite: WebSite;
    public zoom = 5;
    public initialIndex = 0;

    constructor() {
        this.facilityInformation = FACILITY_INFO;
    }
}
